import { ICommand } from 'core-ts-types';
import { courseDetailState } from '../../../routes/ap_course_details_routes';
import { largeCourseGroupCommonState } from '../../../routes/ap_plan_routes';

export const AdvisorSuggestionBlockedStateRoutes = {
  'ap-advisor.retain_suggestions': {
    url: 'retain_suggestions/',
    sticky: true,
    resolve: {
      advisorPlan: (loadAdvisorSuggestedPlanCommand: ICommand) => loadAdvisorSuggestedPlanCommand()
    },
    template: `
            <advisor-blocked-header></advisor-blocked-header>
            <ui-view></ui-view>
            <ui-view name="right-panel-popout" id="advisor-retain-suggestions"></ui-view>
        `
  },
  'ap-advisor.retain_suggestions.suggested_plan': {
    url: 'suggested_plan/',
    template: '<ui-view></ui-view>'
  },
  'ap-advisor.retain_suggestions.suggested_plan.default': {
    url: 'default/',
    template: `
      <advisor-retain-suggestions-suggested-plan></advisor-retain-suggestions-suggested-plan>
    `
  },
  'ap-advisor.retain_suggestions.suggested_plan.default.course_details': {
    ...courseDetailState,
    views: {
      'right-panel-popout@ap-advisor.retain_suggestions': {
        template: `<ap-course-details hide-actions="true"></ap-course-details>`
      }
    }
  },
  'ap-advisor.retain_suggestions.suggested_plan.coursegroup': <ng.ui.IState>{
    ...largeCourseGroupCommonState,
    sticky: true,
    views: {
      '': {
        template: `
          <advisor-retain-suggestions-suggested-plan>
          </advisor-retain-suggestions-suggested-plan>
        `
      },
      'right-panel-popout@ap-advisor.retain_suggestions': {
        template: `<blocked-suggested-plan-large-course-group></blocked-suggested-plan-large-course-group>`
      }
    }
  },
  'ap-advisor.retain_suggestions.blocked_suggestions': {
    url: 'blocked_suggestions/',
    resolve: {
      blockedSuggestions: (loadBlockedSuggestionsCommand: ICommand) => loadBlockedSuggestionsCommand()
    },
    data: {
      pageTitle: 'Blocked suggestions'
    },
    template: `
            <advisor-blocked-suggestions></advisor-blocked-suggestions>
        `
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/planner/ap_advisor_suggestion_blocked_state_routes.ts